/* global autosize, Waypoint, bodyOffset:true, Instafeed, ga */
/* exported mobileSafari, mobileAndroid */

var body;

// Check for mobile (ios/android) browser
var mobileSafari;
var mobileAndroid;

$(function() {
  var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent ),
    android = userAgent.indexOf('android') > -1;

  if(ios) {
    if ( !standalone && safari ) {
      mobileSafari = true;
    }
  }

  if(android) {
    mobileAndroid = true;
  }
});

// Function: Set HTML5 Video Source
function setVideoSrc(src) {
  $('.fs-video__loop source').remove();
  var video = $('.fs-video__loop').append('<source src="'+ src + '">');
  if (video[0]) {
    video[0].load();
    $('.fs-video__loop').on('ended', function () {
      this.load();
      this.play();
    });
  }
}

// Video controls
var mousedown = false;
var video;
$(function() {
  body = $('body');

  var initialized = false;
  var winW = window.innerWidth;
  video = $('.fs-video__loop');
  var bgVideo = $('.bg-video').get(0);
  var NewVideo = $('.home-video');
  var wbHVideo = NewVideo.get(0);
  var PlayBtn = $('.video__controls__btn--play');
  var SoundBtn = $('.video__controls__btn--sound');
  var CloseBtn = $('.video__controls__btn--close');

  var progressBar = document.getElementById('video-progress-bar');

  if(progressBar) {
    progressBar.addEventListener('click', scrubVideo);
    progressBar.addEventListener('mousemove', function(e) {
      mousedown && scrubVideo(e);
    });
    // progressBar.addEventListener('touchmove', function (e) {
    //   mousedown && scrubVideo(e);
    // });
    progressBar.addEventListener('mousedown', function(e) {
      mousedown = true;
      video.pause();
      scrubVideo(e);
    });
    // progressBar.addEventListener('touchstart', function (e) {
    //   mousedown = true;
    //   video.pause();
    //   scrubVideo(e);
    // });
    progressBar.addEventListener('mouseup', function () {
      mousedown = false;
      video.play();
    });
    progressBar.addEventListener('touchend', function () {
      mousedown = false;
      video.play();
    });
  }

  if (winW > 960) {
    setVideoSrc(video.data('vid'));
  } else {
    setVideoSrc(video.data('vidmobile'));
  }

  resizeVideo();

  function resizeVideo() {
    var oldWinW = winW;
    winW = window.innerWidth;
    $(body).removeClass('is-webview');
    var video = $('.fs-video__loop');

    if (!initialized) {
      if (winW > 960) {
        setVideoSrc(video.data('vid'));
      } else {
        setVideoSrc(video.data('vidmobile'));
      }
    }

    if (winW > 960) {
      if (oldWinW <= 960) {
        setVideoSrc(video.data('vid'));
      }
    } else {
      if (oldWinW > 960) {
        setVideoSrc(video.data('vidmobile'));
      }
    }
    initialized = true;
  }

  function scrubVideo(e) {
    var scrubTime = (e.offsetX / progressBar.offsetWidth) * video.duration;
    video.currentTime = scrubTime;
    updateProgressBar();
  }

  $(window).on('resize',resizeVideo);


  $(document).on('click', '.video-play-button', function (e) {
    // var mobTimeout;

    $(body).addClass('js-play-video');
    wbHVideo.play();

    video = document.getElementById('main-video');
    video.addEventListener('timeupdate', updateProgressBar, false);

    if($('.bg-video').length){
      bgVideo.pause();
    }

    if ($(body).hasClass('body--show-nav')) {
      $(body).removeClass('body--show-nav');
    } else {
      $(body).addClass('body--show-nav');


      if (mobileSafari || mobileAndroid) {
        var mobTimeout = null;

        mobTimeout = setTimeout(function() {
          if ($(body).hasClass('js-play-video') && !$(body).hasClass('video--paused')) {
            $(body).removeClass('body--show-nav');
          }
        }, 4000);

        NewVideo.on('touchend', function() {
          if (mobTimeout !== null) {
            if ($(body).hasClass('js-play-video') && !$(body).hasClass('video--paused')) {
              $(body).addClass('body--show-nav');
            }
            clearTimeout(mobTimeout);
          }

          mobTimeout = setTimeout(function() {
            if ($(body).hasClass('js-play-video') && !$(body).hasClass('video--paused')) {
              $(body).removeClass('body--show-nav');
            }
          }, 4000);
        });

      }

    }

    // SHOW NAVIGATION WHEN MOVING MOUSE OVER MOVIE
    if (!mobileSafari && !mobileAndroid) {
      var timeout = null;
      NewVideo.on('mousemove', function() {
        if (timeout !== null) {
          if ($(body).hasClass('js-play-video') && !$(body).hasClass('video--paused') && !mousedown) {
            $(body).addClass('body--show-nav');
          }
          clearTimeout(timeout);
        }
        timeout = setTimeout(function() {
          if ($(body).hasClass('js-play-video') && !$(body).hasClass('video--paused') && !mousedown) {
            $(body).removeClass('body--show-nav');
          }
        }, 1500);
      });
    }

    e.preventDefault();
  });

  function updateProgressBar() {
    var progressBar = $('.video__progress');
    var progressFilled = $('.video__progress__filled');
    var percentage = Math.floor((100 / video.duration) * video.currentTime);
    progressBar.value = percentage;
    progressFilled.css('width', percentage + '%');
  }

  $(window).load(function() {
    if (NewVideo.length) {
      wbHVideo.onended = function() {
        $(CloseBtn).trigger('click');
      };
    }
  });

  PlayBtn.on('click', function(e) {
    wbHVideo[wbHVideo.paused ? 'play' : 'pause']();
    e.stopPropagation();

    $(this).toggleClass('icon-play');
    $(this).toggleClass('icon-pause');
    $(body).toggleClass('video--paused');

    e.preventDefault();
  });

  SoundBtn.on('click', function(e) {
    if( NewVideo.prop('muted') ) {
      NewVideo.prop('muted', false);
    } else {
      NewVideo.prop('muted', true);
    }
    e.stopPropagation();

    $(this).toggleClass('icon-sound-off');
    $(this).toggleClass('icon-sound-on');

    e.preventDefault();
  });

  CloseBtn.on('click', function(e) {
    wbHVideo.pause();
    wbHVideo.currentTime = 0;
    NewVideo.prop('muted', false);

    $(body).removeClass('js-play-video');
    $(body).removeClass('video--paused');
    $(body).removeClass('body--show-nav');
    PlayBtn.removeClass('icon-play').addClass('icon-pause');
    SoundBtn.removeClass('icon-sound-off').addClass('icon-sound-on');

    if($('.bg-video').length){
      bgVideo.play();
    }

    e.preventDefault();
  });

  // WAYPOINTS:
  // toggleClass when top of menu is on top!
  $('.band--menu-main').waypoint(function(){
    $('.header--main .hamburger').toggleClass('is-active');
    $('body').toggleClass('menu-is-active');
    // $('.header--main').toggleClass('header--background');
  },{
    offset: 0
  });

  // toggleClass when header is scrolled
  $('.band--header').waypoint(function(){
    $('body').addClass('scrolled');
  },{
    offset: -200
  });

  // start backgroundvideo when .site has 50% offset
  if($('.site').length){

    if($('.bg-video').length){
      bgVideo.pause();
    }

    $('.site').waypoint(function(direction){

      if(direction==='down') {
        if($('.bg-video').length){
          bgVideo.play();
        }
      } else {
        setTimeout(function(){
          if($('.bg-video').length){
            bgVideo.pause();
          }
        }, 1000);
      }
    },{
      offset: 'bottom-in-view'
    });
  }

  // Hamburger toggle
  bodyOffset = -1;
  $('.header--main .hamburger').on('click', function() {

    // HAMBURGER IS (X) = ACTIEF
    if ($(this).hasClass('is-active')) {

      // VIDEO WORDT GETOOND
      if ($(body).hasClass('body--show-video')) {
        $(this).removeClass('is-active');
        $(body).removeClass('menu-is-active');
        $(body).removeClass('body--show-video');

        // HOME
        if(!$('.site').length){
          if($('.bg-video').length){
            bgVideo.play();
          }
        // VERVOLG
        } else {
          $('html, body').animate({ scrollTop: $('.site').offset().top + $('.site').innerHeight()}, 0);
        }

      // VIDEO WORDT NIET GETOOND
      } else {

        // VERVOLGPAGINA'S
        if($('.site').length){

          // SCROLL NAAR BOVENKANT VIDEO
          if (bodyOffset == -1){
            $('html, body').animate({ scrollTop: $('.band--menu-main').offset().top - window.innerHeight }, 300);

          // SCROLL NAAR OFFSET .SITE
          } else {
            $('html, body').animate({ scrollTop: bodyOffset}, 10);
            bodyOffset = -1;
          }

        // HOME
        } else {
          $('html, body').animate({ scrollTop: $('.band--menu-main').offset().top - window.innerHeight }, 300);
        }
      }

    // HAMBURGER IS (=) (NIET ACTIEF)
    } else {
      bodyOffset = $('body').scrollTop();

      // VERVOLG
      if($('.site').length){
        $('html, body').animate({ scrollTop: $('.band--menu-main').offset().top}, 10);
      // HOME
      } else {
        $('html, body').animate({ scrollTop: $('.band--menu-main').offset().top}, 300);
      }

      $(body).removeClass('body--show-video').removeClass('body--show-nav').removeClass('video--paused');

      if($('.bg-video').length){
        bgVideo.play();
      }
    }

    Waypoint.refreshAll();
  });
});

// Flipper / contact cards
$(function() {
  $('.flipper__toggle-button--back').on('click', function() {
    $('.flipper__cards').addClass('flipper__cards--back');
    $('.flipper__toggle-button').removeClass('flipper__toggle-button--active');
    $(this).addClass('flipper__toggle-button--active');
  });

  $('.flipper__toggle-button--front').on('click', function() {
    $('.flipper__cards').removeClass('flipper__cards--back');
    $('.flipper__toggle-button').removeClass('flipper__toggle-button--active');
    $(this).addClass('flipper__toggle-button--active');
  });
});

function updateForm() {
  // Resize textarea
  $('textarea').each(function(){
    $(this).removeAttr('rows').removeAttr('cols');
    autosize(this);
  });

  // Contact form labels
  $(document).on('input change', '.form input, .form textarea', function() {
    $(this).closest('.form__field').removeClass('input--not-empty');
    if ($(this).val() !== '') {
      $(this).closest('.form__field').addClass('input--not-empty');
    }
  });

  $(document).on('focus', '.form input, .form textarea', function() {
    $(this).closest('.form__field').addClass('input--has-focus');
  });

  $(document).on('blur', '.form input, .form textarea', function() {
    $(this).closest('.form__field').removeClass('input--has-focus');
  });

}

$(function() {
  updateForm();

  // Again after gform post
  $(document).bind('gform_post_render', function(){
    updateForm();

    $('.form input, .form textarea').each(function(){
      if ($(this).val() !== '') {
        $(this).closest('.form__field').addClass('input--not-empty');
      }
    });
  });
});

// Team hover effect
$(function() {
  $('.team__member' ).each( function() {
    $(this).hoverdir();
  });
});

// Owlcarousel
$(function() {
  if($('.carousel').length){
    $('.carousel').owlCarousel({
      loop: true,
      items: 1,
      margin: 5,
      dots: true,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true
    });
  }

  if($('.case-slider').length){
    $('.case-slider').owlCarousel({
      loop: true,
      items: 1,
      margin: 0,
      dots: true
    });
  }
});

// Dynamic Scrollto links
$(function() {
  $(document).on('click', '.scrollto', function(e) {
    var defaultAnchorOffset = 0;
    var anchor = $(this).attr('data-attr-scroll');
    var anchorOffset = $(this).attr('data-scroll-offset');
    if (!anchorOffset)
      anchorOffset = defaultAnchorOffset;
    $('html,body').animate({ scrollTop: $('.'+anchor).offset().top - anchorOffset }, 300);
    e.preventDefault();
  });
});

// Instagram
$(function() {
  if($('#instafeed').length){
    var feed = new Instafeed({
      resolution: 'standard_resolution',
      get: 'user',
      useHttp: true,
      userId: '3192781293',
      clientId: '81b3ae77cb154b63b21b464c845eac80',
      accessToken: '3192781293.1677ed0.9ae0c6e7f0d44c9498091c3d0e3e44b4',
      limit: 4,
      template: '<a target="_blank" class="instagram__item" href="{{link}}" style="background-image: url(\'{{image}}\');"><div class="instagram__likes">{{likes}}</div></a>'
    });
    feed.run();
  }
});

// Show number of available jobs in menu
$(function() {
  if ($('#menu-item-33').length > 0) {
    $.getJSON('https://www.werkenbijtres.nl/wp-json/wp/v2/job', function(result) {
      if (result) {
        $('#menu-item-33').append('<span class="count">' + result.length + '</span>');
      }
    });
  }
});

// Colorbox
$(function() {
  $('.colorbox--video').colorbox({
    close: '<div class="hamburger hamburger--spin is-active"><span class="hamburger-box"><span class="hamburger-inner"></span></span></div>',
    width: '95%',
    height: '95%',
    maxWidth: '1920px',
    maxHeight: '1080px',
    fadeOut: 0,
    transition: 'none',
    fixed: true,
    iframe:true
  });

  $('.gallery__link').colorbox({
    close: '<div class="hamburger hamburger--spin is-active"><span class="hamburger-box"><span class="hamburger-inner"></span></span></div>',
    rel: 'gallery',
    photo: true,
    current: 'afbeelding {current} van {total}',
    maxWidth: '90%',
    maxHeight: '85%',
    previous: '<span class="icon icon-left-arrow"></span>',
    next: '<span class="icon icon-right-arrow"></span>'
  });
});

function stopAnimation() {
  $('.hc-list__overlay').each(function(){
    $(this).addClass('notransition');
  });
}

// Before/After slider
$(function() {
  $('.cocoen').cocoen();

  $('.cocoen').waypoint(function(){
    $('body').addClass('cocoen-visible');
  },{
    offset: '50%'
  });
});

// INTRO - ANIMATION
$(window).load(function() {
  $('body').addClass('start');
  Waypoint.refreshAll();

  setTimeout(function(){
    $(window).on('resize', stopAnimation);
  }, 1600);

});

$(function() {
  $('.intro-txt__quote span').lettering();
});

// OPEN SOLLICITATIEFORMULIER
$(function() {
  $('.open-form').on('click', function(e) {
    $(this).addClass('hide');
    $(this).closest('.band__content').find('h2').addClass('hide');
    $(this).closest('.band__content').find('p:not(.bold)').addClass('hide');
    $('.band--form').removeClass('band--hidden');
    $('html,body').animate({ scrollTop: $('.band--form').offset().top - 100 }, 300);
    e.preventDefault();
  });
});

// TOGGLE-BOX
$(function() {
  $('.toggle-block__title').on('click', function(e) {

    if ($(this).closest('.toggle-block').hasClass('toggle-block--active')) {
      $(this).closest('.toggle-block').removeClass('toggle-block--active');
    } else {
      $('.toggle-block').removeClass('toggle-block--active');
      $(this).closest('.toggle-block').addClass('toggle-block--active');
    }


    e.preventDefault();
  });
});

// Track whitepaper downloads
$(function() {
  $('.band--downloads .grid__link').on('click', function() {
    if (ga) {
      ga('send', 'event', 'whitepaper', 'download', [
        $(this).attr('href')
      ]);
    }
  });

  $('.band--job-footer .button--large').on('click', function () {
    if (ga) {
      ga('send', 'event', 'job', 'click', [
        document.title
      ]);
    }
  });
});
